<template>
    <div>
        <Header />
        <div class="banners">
            <Banner :src="src" />
        </div>
        <div class="join_container">
            <h2>业绩报告</h2>
            <ul class="incestor_ul">
				<li
					v-for="(item, index) in investor_business_list"
					:key="index"
					class="news_items"
                    @click="goDetail(index)"
				>   
                    <div class="listTable">
                        <div class="imgBox">
                            <img :src="item.bd_coverpicturecn" alt="">
                        </div>
                        
                        <p>{{item.bd_titlecn}}</p>
                    </div>
				</li>
			</ul>    
        </div>
        <Footer />
    </div>
</template>
<script>
import Header from '../../components/Header.vue';
import Banner from '../../components/Banner.vue';
import Footer from '../../components/Footer.vue';
import Axios from 'axios'
import Vue from 'vue'
Vue.config.warnHandler = function(msg, vm, trace) {
    console.log(`Warn: ${msg}\nTrace: ${trace}`);
  }
const Base64=require('js-base64');
export default {
    components:{
        Header,
        Banner,
        Footer,
    },
    data(){
        return{
            src:'',
            investor_business_list: [],
        }
    },
    mounted(){
         Axios({
			url: '/apiv2/sconfig/getlist',
			data: {},
			method: 'GET',
		}).then((res) => {
        let common=res.data.data.rows;
				for(var i=0;i<common.length;i++){
					
					if(common[i].sc_key.slice(0,6)=="JOINUS"){
						this.src=common[i].sc_value
					}
				}
        })
           
            Axios({
				url:'/apiv2/bdoc/getlist?bdContenttype=业绩报告',
				data:{},
				method:'GET',
			}).then((res)=>{
				for(var j=0;j<res.data.data.rows.length;j++){
                    res.data.data.rows[j].bd_coverpicturecn= res.data.data.rows[j].bd_coverpicturecn
					this.investor_business_list.push(res.data.data.rows[j])
				}
			})
    },
    methods:{
        goDetail(index){
			this.$router.push({
				path:'/joinDetail',
				query:{
					detailText:this.investor_business_list[index].bd_pdfcn
				}
			})
		}
    }
}
</script>
<style lang="scss" scoped>
@media (min-width: 1200px){
    @import '../../style/base.scss';
    .join_container{
        width:70%;
        margin: 0 auto;
        padding: 30px 0 80px;
        h2{
            font-size: 32px;
            line-height: 120px;
            font-weight: 550;
        }
        ul{
		    width:100%;
            display: flex;
            flex-wrap: wrap;
            li{
                cursor: pointer;
                width:29%;
                margin-left: 30px;
                margin-top: 40px;
                border: 1px solid #ccc;
                .listTable{
                    width: 100%;
                    height: 190px;
                   .imgBox{
                       width: 100%;
                       height: 150px;
                       overflow: hidden;
                       img{
                        width: 100%;
                        height: 150px;
                        }
                   }
                    p{
                        height: 38px;
                        font-size: 14px;
                        font-weight: bold;
                        text-align: center;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        line-height: 38px;
                        border: 1px solid #f2f2f2;
                        color: #333;
                        background: #f2f2f2;
                    }
                }
            }
            li:hover{
                .listTable{
                    .imgBox{
                        img{
                            transform: scale(1.1);
                        }
                    }
                    p{
                        color: white;
                        background: #274a7d;
                    }
                }
                color: #274a7d;
            }
	}
    }
}
@media (max-width: 1199px){
    @import '../../style/mb.scss';
    .join_container{
       width: 90%;
       margin: 0 auto;
       padding-bottom: 50px;
       h2{
           font-size: 24px;
           line-height: 60px;
           font-weight: 550;
       }
       ul{
           width: 100%;
           display: flex;
           flex-wrap: wrap;
           li{
               width: 100%;
               margin-top:30px;
               .listTable{
                   width: 100%;
                   height: 190px;
                   .imgBox{
                       width: 100%;
                       height: 150px;
                       img{
                           width: 100%;
                           height: 150px;
                       }
                   }
                   p{
                       height: 38px;
                       font-size: 14px;
                       line-height: 38px;
                       white-space: nowrap;
                       text-overflow: ellipsis;
                       border: 1px solid #f2f2f2;
                       color:#333;
                       background: #f2f2f2;
                       text-align: center;
                   }
               }
           }
       }
    }
    .footer{
        padding: 0 rm(20);
    }
}

</style>